import { norlizeColumns } from 'utils/handle'

// 任务管理
const DailyTaskColumnsMaps = new Map()
DailyTaskColumnsMaps.set('employeeName', '人员')
DailyTaskColumnsMaps.set('type', '类别')
DailyTaskColumnsMaps.set('content', '任务说明')
DailyTaskColumnsMaps.set('costTime', '耗费时间')
DailyTaskColumnsMaps.set('reportTime', '任务时间')
DailyTaskColumnsMaps.set('status', {
    label: '状态',
    formatter: row => StatusValidDisplayEnmus.find(v => v.value === row.status).label
})


class DailyTask {
    constructor(v) { // 构造函数
        v = v || {}
    }

    static get tableColumns () {
        return norlizeColumns(
            ['employeeName', 'type', 'content', 'costTime', 'reportTime'],
            DailyTaskColumnsMaps
        )
    }
}


export {
    DailyTask
}


// WEBPACK FOOTER //
// ./src/views/task-manage/taskDTO.js